<template>
  <v-container py-0>
    <v-card class="fill-height">
      <v-container>
        <v-list-item one-line>
          <v-list-item-content>
            <v-list-item-title class="headline">
              Mes clientes
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-row>
          <v-col>
            <v-list subheader>
              <v-list-item
                v-for="client in clients"
                :key="client.id"
                @click="handleClick(client)"
              >
                <!--<v-list-item-avatar>
                  <v-img :src="item.avatar"></v-img>
                </v-list-item-avatar>-->

                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      client.first_name + " " + client.last_name.toUpperCase()
                    }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-icon @click="edit(client)">
                  <v-icon>edit</v-icon>
                </v-list-item-icon>
                <v-list-item-icon @click="del(client)">
                  <v-icon color="red">
                    clear
                  </v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-row
              justify="center"
              align="center"
            >
              <v-btn
                color="primary"
                dark
                class="mb-2"
                rounded
                @click="newClient"
              >
                Ajouter un Client
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-row justify="center">
      <v-dialog
        v-if="selectedClient"
        v-model="dialog"
        scrollable
        max-width="500px"
      >
        <v-card>
          <v-card-title>
            {{
              mode == "create" ? "Ajouter un client" : "Editer le client"
            }}
          </v-card-title>
          <v-divider />
          <v-card-text style="height: 300px;">
            <v-row>
              <v-col>
                <v-text-field
                  v-model="selectedClient.first_name"
                  label="Prénom"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="selectedClient.last_name"
                  label="Nom"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="selectedClient.mail"
                  label="E-Mail"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions class="justify-center">
            <v-btn
              color="blue darken-1"
              text
              @click="close"
            >
              Annuler
            </v-btn>
            <v-btn
              color="blue darken-1"
              rounded
              dark
              @click="refresh('client/' + mode)"
            >
              Valider
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    clients: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      mode: 'create',
      selectedClient: null,
    };
  },
  methods: {
    handleClick(item) {
      this.$emit('newClient', item);
    },
    newClient() {
      this.selectedClient = {
        last_name: '',
        first_name: '',
        mail: '',
      };
      this.mode = 'create';
      this.dialog = true;
    },
    edit(client) {
      this.selectedClient = JSON.parse(JSON.stringify(client));
      this.mode = 'edit';
      this.dialog = true;
    },
    async refresh(action) {
      if (this.selectedClient) {
        await this.$store.dispatch(
          action,
          JSON.parse(JSON.stringify(this.selectedClient)),
        );
        this.close();
        this.$emit('refreshClient');
      }
    },
    async del(client) {
      this.selectedClient = JSON.parse(JSON.stringify(client));
      await this.refresh('client/delete');
      this.selectedClient = null;
      this.$emit('newClient', null);
    },
    close() {
      this.dialog = false;
      this.selectedClient = null;
    },
  },
};
</script>

<style></style>
